exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-3970c0ee] table > tbody > tr > td {\n\tcursor: pointer;\n}\ninput[type='texte'][data-v-3970c0ee] {\n\twidth: 100%;\n\tpadding: 12px 20px;\n\tmargin: 4px 0;\n\tbox-sizing: border-box;\n\tborder: none;\n\tbackground-color: white;\n\tcolor: white;\n}\n", ""]);

// exports
